module.exports = __webpack_public_path__ + "static/chinaRep-8001985f498ab2adebf62e1320b88026.jpg";